import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTER_PATHS } from '../constants';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  constructor(private readonly router: Router) {}

  navigateToDashboard() {
    this.router.navigate([ROUTER_PATHS.root, ROUTER_PATHS.dashboard.root]);
  }

  navigateToLogin() {
    this.router.navigate([ROUTER_PATHS.auth.root, ROUTER_PATHS.auth.login]);
  }

  navigateToSignUp() {
    this.router.navigate([ROUTER_PATHS.auth.root, ROUTER_PATHS.auth.signUp]);
  }

  navigate(commands: string[], navigationExtras?: { [key: string]: any } | undefined): Promise<boolean> {
    return this.router.navigate(commands, navigationExtras);
  }

  navigateToInstructorDetail(instructorId: number | null): void {
    this.router.navigate([ROUTER_PATHS.members.root, ROUTER_PATHS.members.instructors], { queryParams: { instructorId: instructorId } });
  }

  navigateToStudentDetail(dependentId: number | null): void {
    this.router.navigate([ROUTER_PATHS.members.root, ROUTER_PATHS.members.clients], { queryParams: { dependentId: dependentId } });
  }

  navigateToAccountManager(accManagerId: number | null): void {
    this.router.navigate([ROUTER_PATHS.members.root, ROUTER_PATHS.members.clients], { queryParams: { accManagerId } });
  }

  navigateToSupervisorDetail(supervisorId: number | null): void {
    this.router.navigate([ROUTER_PATHS.members.root, ROUTER_PATHS.members.supervisors], { queryParams: { supervisorId: supervisorId } });
  }

  navigateToDeskManagerDetail(deskManagerId: number | null): void {
    this.router.navigate([ROUTER_PATHS.members.root, ROUTER_PATHS.members.deskManagers], { queryParams: { deskManagerId } });
  }

  navigateToLaunchPage() {
    this.router.navigate([ROUTER_PATHS.launchPage]);
  }
}
